// Generated by `yarn tokens:import --aos-ds` from the Figma component "WeekdayLabel" (7189:36930). Do not edit.
//
// This component is composed rather than a variant matrix, so the contract
// carries the tokens its Figma node binds and the component is written by hand.
// The spec asserts the two agree exactly — see dsComposedModule in
// packages/aos-ui-universal/scripts/tokens-import.mjs for why.

export type ContractProp =
    | { kind: 'text' }
    | { kind: 'boolean' }
    | { kind: 'instance_swap' }
    // A slot is also a declared property, not only a node in the tree.
    | { kind: 'slot' }
    | { kind: 'variant'; values: readonly string[] }

export type TokenSubstitution = { was: string; now: string; value: number; why: string }

export type ContractComposition = { component: string; variants: readonly string[] }

/** `variable: null` is a removal: the main component binds it, this instance does not. */
export type InstanceOverride = {
    path: string
    property: string
    variable: string | null
    was: string | null
}

/** Where the caller puts content — `children`, or a prop per named slot. */
export type ContractSlot = { path: string; name: string }

export const weekdaylabelContract = {
    component: 'WeekdayLabel',
    nodeId: '7189:36930',
    section: '[Web] Pickers',
    textStyleIds: ['S:3379f3e69d79bb20e0ffc8221eaedd982424986d,'],
    figmaTokens: ['content/default'],
    // What the bound text style is made of. On record, not asserted against
    // classes: these reach the page as Typography's variant, not as a class.
    textTokens: ['family/family', 'line-height/p3', 'size/p3', 'weight/medium'] as string[],
    // Inherited from the components this one instantiates. Verified in their
    // own contracts, so drift.ts subtracts these rather than counting them here.
    childTokens: [] as string[],
    composes: [] as ContractComposition[],
    overrides: [] as InstanceOverride[],
    slots: [] as ContractSlot[],
    props: {},
    substituted: [] as TokenSubstitution[],
} as const
